import React from 'react';
export function Footer() {
  return <footer className="w-full bg-paper px-5 py-10" data-id="element-86" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="3gfsoch60l2p3">
        <p className="font-serif-display text-base font-semibold text-ink" data-id="element-88" data-mp="3ghc3u5juj9pt">
          Visual Chemistry™
        </p>
        <p className="mt-2 text-xs leading-relaxed text-ink/50" data-id="element-89" data-mp="32m1c310wf4po">
          Digital Product · No Physical Shipment
          <br data-id="element-90" data-mp="3ufa4k858v7mu" />
          One-Time Payment · No Subscription
          <br data-id="element-91" data-mp="3uftlblj5rpza" />
          For individual classroom use. Redistribution or resale is not permitted.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-92" data-mp="36ms6hozeurf">
          Illustrations may be simplified for educational purposes. Written formulas, values, units,
          and explanations should be used as the scientific reference.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-93" data-mp="29ynmxp3fzdg4">
          © 2026 Visual Chemistry™ by THE RESOURCE LAB. All rights reserved.
        </p>
      </div>
    </footer>;
}